import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { id: "inwide2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "1998-2023 © Завод «Аврора-НЕФТЬ»"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ООО «Завод нефтегазового оборудования «АВРОРА-НЕФТЬ»"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("ИНН 6455061470,     КПП 645101001,     ОГРН 1146455001043")
  ])
], -1)
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "menu-menyu-v-podvale-container" }
const _hoisted_6 = {
  id: "menu-menyu-v-podvale",
  class: "menu"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://aurora-oil.ru/about/news/"
  }, "Новости")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://aurora-oil.ru/about/articles/"
  }, "Статьи")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/about" }, {
                default: _withCtx(() => [
                  _createTextVNode("О заводе")
                ]),
                _: 1
              })
            ]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/about/delivery" }, {
                default: _withCtx(() => [
                  _createTextVNode("Доставка")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/about/patents" }, {
                default: _withCtx(() => [
                  _createTextVNode("Сертификаты и патенты")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/about/gallery" }, {
                default: _withCtx(() => [
                  _createTextVNode("Фото и видео")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_9
    ])
  ]))
}